var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.633,
    height: 120.392,
    viewBox: "0 0 78.633 120.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M182.463,18.047h8.194a2.463,2.463,0,1,0,0-4.925h-8.194a2.463,2.463,0,0,0,0,4.925",
    transform: "translate(-147.247 -4.056)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M187.775,127.232h-1.313a2.463,2.463,0,0,0,0,4.925h1.313a2.463,2.463,0,1,0,0-4.925",
    transform: "translate(-147.804 -19.948)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M143.447,111.581A10.317,10.317,0,0,0,153.739,121.9h55.468A10.316,10.316,0,0,0,219.5,111.581v-97.2A10.3,10.3,0,0,0,209.206,4.089H153.739a10.3,10.3,0,0,0-10.292,10.292c0,49.06,0-37.765,0,97.2Zm71.127-9.05h-66.2V24.179h66.2Zm-5.367,14.443H153.739a5.385,5.385,0,0,1-5.367-5.393v-4.126h66.2v4.126a5.385,5.385,0,0,1-5.367,5.393M153.739,9.015h55.468a5.373,5.373,0,0,1,5.367,5.368v4.873h-66.2V14.382A5.373,5.373,0,0,1,153.739,9.015Z",
    transform: "translate(-142.156 -2.798)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M209,122.981H153.53a11.608,11.608,0,0,1-11.582-11.609h0v-79c0-.407,0-.766.005-1.082h-.005v-.862c0-1.616,0-5.92,0-16.259A11.6,11.6,0,0,1,153.53,2.589H209A11.6,11.6,0,0,1,220.58,14.172v97.2A11.608,11.608,0,0,1,209,122.981M144.529,31.293v80.079h0a9.023,9.023,0,0,0,9,9.026H209a9.023,9.023,0,0,0,9-9.026v-97.2a9.01,9.01,0,0,0-9-9H153.53a9.01,9.01,0,0,0-9,9V31.293ZM209,118.056H153.53a6.679,6.679,0,0,1-6.658-6.684v-5.417h68.785v5.417A6.68,6.68,0,0,1,209,118.056m-59.544-9.519v2.834a4.094,4.094,0,0,0,4.076,4.1H209a4.094,4.094,0,0,0,4.076-4.1v-2.834Zm66.2-4.924H146.873V22.679h68.784Zm-66.2-2.582h63.62V25.261h-63.62Zm66.2-80.693H146.871V14.174a6.667,6.667,0,0,1,6.659-6.659H209a6.666,6.666,0,0,1,6.658,6.659Zm-66.2-2.583h63.621V14.174A4.081,4.081,0,0,0,209,10.1h-55.47a4.08,4.08,0,0,0-4.076,4.076Z",
    transform: "translate(-141.947 -2.589)",
    fill: "#314164"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9b3d03d9b41cf984b00ca331cb772057.svg";
export { ForwardRef as ReactComponent };